import React, { useState } from 'react';
import { BoxProps, Body, Box, Tooltip } from '@hover/blueprint';
import InfoIconGray from '../../../assets/svgs/InfoIconGray';
import { IPricingTooltip } from '../../../interfaces/IPricingTooltip';
import { useClickOutside } from '../../../hooks';

interface Props extends BoxProps {
  tooltip: IPricingTooltip;
}

const PricingTooltip: React.FC<Props> = ({ tooltip, ...restProps }) => {
  const [isOpen, setOpen] = useState<boolean>(false);
  const toggleToolTip = () => setOpen(!isOpen);

  const { componentRef } = useClickOutside(setOpen);
  return (
    <Box
      zIndex={10}
      ref={componentRef}
      {...restProps}
      onMouseEnter={() => setOpen(true)}
      onClick={toggleToolTip}
      onMouseLeave={() => setOpen(false)}
    >
      <Tooltip
        placement="top"
        hasArrow={false}
        isOpen={isOpen}
        label={tooltip.tooltip}
        bg="brandNavy.500"
        p={200}
        fontSize={200}
        fontWeight={600}
      >
        <Box>
          <Box flexDir={{ base: 'column', desktop: 'row' }} alignItems="center">
            <Body mr={100} size={{ base: 500, tablet: 600 }}>
              {tooltip.title}
            </Body>
            {tooltip.subTitle ? (
              <Body size={200}>{tooltip.subTitle}</Body>
            ) : null}
          </Box>
          <Box ml={100} pt={100} mt={50} zIndex={10}>
            <InfoIconGray />
          </Box>
        </Box>
      </Tooltip>
    </Box>
  );
};

export default PricingTooltip;
